<template>
  <div class="overlay bg-white">
    <div class="d-block my-auto w-100 text-center">
      <div class="bouncing-loader">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingOverlay'
};
</script>

<style scoped>
/* Spinner for Waitboxes and inbetween Steps */
.bouncing-loader {
  display: flex;
  justify-content: center;
}
.bouncing-loader > div {
  width: 1rem;
  height: 1rem;
  margin: 3rem 0.2rem;
  background: #bccf00;
  border-radius: 50%;
  animation: bouncing-loader 0.6s infinite alternate;
}
.bouncing-loader > div:nth-child(2) {
  animation-delay: 0.2s;
}
.bouncing-loader > div:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes bouncing-loader {
  to {
    opacity: 0.5;
    transform: translate3d(0, -1rem, 0);
  }
}
</style>
